import apiConfig from "constants/apiConfig";
import { Collaboration, Collaborations, Milestone } from "types/campaign/collaborations";
import axiosClient from "utils/axiosClient";

export const fetchCampaignCollaborations = async (
    campaignId: string,
    payload: Record<string, unknown>
): Promise<Collaborations> => {
    const response = await axiosClient.get(
        apiConfig.FETCH_CAMPAIGN_COLLABORATIONS.url.replace('<campaignId>', campaignId),
        { params: payload }
    );

    return response.data;
};

export const fetchCollaboration = async (
    campaignId: string,
    collaborationId: string
): Promise<{ collaboration: Collaboration, milestones: Milestone[], chat: { uuid: string } | null }> => {
    const response = await axiosClient.get(
        apiConfig.FETCH_COLLABORATION.url
            .replace('<campaignId>', campaignId)
            .replace('<collaborationId>', collaborationId)
    );

    return response.data;
};
